/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminCreate } from '../models/AdminCreate';
import type { AdminDetails } from '../models/AdminDetails';
import type { AdminUpdate } from '../models/AdminUpdate';
import type { AuthorizedDistrictDelete } from '../models/AuthorizedDistrictDelete';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { UserLoginAttemptDetails } from '../models/UserLoginAttemptDetails';
import { request as __request } from '../core/request';

export class AdminsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async adminsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/admins/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/admins/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async adminsVGetLoginAttemptsById(
        userId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/admins/${userId}/LoginAttempts/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns UserLoginAttemptDetails OK
     * @throws ApiError
     */
    public static async adminsVGetLoginExport(
        userId: string,
        requestBody?: PagingQuery,
    ): Promise<UserLoginAttemptDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/admins/${userId}/LoginAttempts/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns AdminDetails Created
     * @throws ApiError
     */
    public static async adminsVCreate(
        requestBody?: AdminCreate,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/admins`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns any No Content
     * @throws ApiError
     */
    public static async adminsVDelete(
        userId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/admins/${userId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVGetById(
        userId: string,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/admins/${userId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns AdminDetails OK
     * @throws ApiError
     */
    public static async adminsVUpdate(
        userId: string,
        requestBody?: AdminUpdate,
    ): Promise<AdminDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/admins/${userId}`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param userId
     * @param requestBody
     * @returns any No Content
     * @throws ApiError
     */
    public static async adminsVDeleteAuthorizedDistricts(
        userId: string,
        requestBody?: Array<AuthorizedDistrictDelete>,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/admins/${userId}/authorized-districts`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @returns any No Content
     * @throws ApiError
     */
    public static async adminsVDeactivateAdmins(
        operatorId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/admins/deactivate/${operatorId}`,
        });
        return result.body;
    }

}